/** @enum {string} */
export const Environments = Object.freeze({
  DEV: 'DEV',
  QUOTAS: 'QUOTAS',
  SANDBOX: 'SANDBOX',
  TEST: 'TEST',
  STAGING: 'STAGING',
  PROD: 'PROD',
  NEW_SANDBOX: 'NEW_SANDBOX',
  NEW_STAGING: 'NEW_STAGING',
  MACCS_STAGING_URL_PATTERN: 'MACCS_STAGING_URL_PATTERN',
  MACCS_PROD_URL_PATTERN: 'MACCS_PROD_URL_PATTERN'
})
